import { Typography, Stack, Divider } from '@mui/material';
import { Button } from 'design-system';

// TODO: Remove hardcoded values once BE complete. (Note: Subject to change)
const SearchCardResult = ({ inputValue, onSubmit }: { inputValue: string; onSubmit: () => void }) => {
  return (
    <>
      <Divider sx={(theme) => ({ paddingX: theme.spacing(1) })} />
      <Stack
        sx={[
          {
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0.5,
          },
          (theme) => ({ padding: theme.spacing(1), textAlign: 'center' }),
        ]}
      >
        <Typography variant="body1" color="primary" sx={(theme) => ({ fontWeight: theme.typography.fontWeightMedium })}>
          Can&rsquo;t find what you are looking for?
        </Typography>
        <Typography variant="body2">
          Submit &lsquo;<strong>{inputValue}</strong>&rsquo; as a special request and we will source it for you.
        </Typography>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Submit a special request
        </Button>
      </Stack>
    </>
  );
};

export default SearchCardResult;
